import JoinHeader from "./join-header";

document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelector("#js-hotels.hotels-index") && !document.querySelector("#js-hotels-spec-index")) {
    return;
  }
  JoinHeader();
});
